import React, { useRef } from 'react'
import Script from 'next/script'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { DEFAULT_LOCALE } from '~/config/constants'
import { Headline } from '~/elements/Headline/Headline'
import { useInView } from 'react-intersection-observer'
import { createLanguageRegionLocale } from '~/lib/createLanguageRegionLocale'

type Props = {
  sku?: string
}

const Instagram = ({ sku }: Props) => {
  const { t } = useTranslation()
  const router = useRouter()
  const [ref, inView] = useInView({ triggerOnce: true })

  const containerName = 'js-flowbox-flow'
  const flowKey = process.env.NEXT_PUBLIC_FLOWKEY_PDP

  return (
    <section className="max-w-[100vw] overflow-hidden pb-4 lg:pb-0" ref={ref}>
      <Headline type="h2" styleAs="slider" className="px-4 pt-8 pb-3 lg:px-20 lg:pt-16 lg:pb-4">
        {t('Share your Style')}
      </Headline>
      <Headline type="p" styleAs="p" className="px-4 pb-6 lg:px-20 lg:pb-8">
        {t('Tag your posts with #MYBENUTA and show us your style!')}
      </Headline>
      <div id={containerName} />
      {inView ? (
        <>
          <Script
            id="flowbox-init"
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
              __html: `  (function(d, id) {
    if (!window.flowbox) { var f = function () { f.q.push(arguments); }; f.q = []; window.flowbox = f; }
    if (d.getElementById(id)) {return;}
    var s = d.createElement('script'), fjs = d.scripts[d.scripts.length - 1]; s.id = id; s.async = true;
    s.src = ' https://connect.getflowbox.com/flowbox.js';
    fjs.parentNode.insertBefore(s, fjs);
  })(document, 'flowbox-js-embed');`,
            }}
          />
          <Script
            id={`flowbox-${sku}`}
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
              __html: `window.flowbox('init', {
container: '#${containerName}',
key: '${flowKey}',
locale: '${router.locale ? createLanguageRegionLocale(router.locale) : DEFAULT_LOCALE}',
productId: '${sku}'
})`,
            }}
          />
        </>
      ) : null}
    </section>
  )
}

export default Instagram
